export default "/_nuxt/2e160c9f1ad768e3f459dbd0a5446087.svg";